import { render, staticRenderFns } from "./BussinessProcessEventsForm.vue?vue&type=template&id=0fdb6831&"
import script from "./BussinessProcessEventsForm.vue?vue&type=script&lang=js&"
export * from "./BussinessProcessEventsForm.vue?vue&type=script&lang=js&"
import style0 from "./BussinessProcessEventsForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QIcon,QSeparator,QCardActions,QBtn,QSpace,QField} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QIcon,QSeparator,QCardActions,QBtn,QSpace,QField}, component.options.components || {})
